import { RouteObject } from 'react-router-dom';

import { Businesses } from '@/pages/Fleet';
import { ViewBusiness, NewBusiness, EditBusiness } from '../pages';

export const BusinessesRoutes: RouteObject[] = [
  {
    path: 'businesses',
    element: <Businesses />,
  },
  {
    path: 'businesses/profile/:id',
    element: <ViewBusiness />,
  },
  {
    path: 'businesses/profile/:id/edit',
    element: <EditBusiness />,
  },
  {
    path: 'businesses/new',
    element: <NewBusiness />,
  },
];
